module.exports = __webpack_public_path__ + "b1507fba2fd2d0c9862e4de5b6415466.pdf";